import React, { useState } from "react";

function FAQsPricing() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does it cost to have junk removal?",
      content: `
       This is just a dummy text that has been inserted as a
                          placeholder for future content. While it may seem
                          insignificant at first glance, the use of dummy text
                          is a common practice in the design and publishing
                          industry, as it allows designers and developers to
                          visualize the layout and overall aesthetic of a
                          project without being distracted by the actual
                          content.
      `,
    },
    {
      title: "Is a junk removal quote free?",
      content: `
        This is just a dummy text that has been inserted as a
                          placeholder for future content. While it may seem
                          insignificant at first glance, the use of dummy text
                          is a common practice in the design and publishing
                          industry, as it allows designers and developers to
                          visualize the layout and overall aesthetic of a
                          project without being distracted by the actual
                          content.
      `,
    },
    {
      title:
        "Can you remove furniture during a property cleanout or renovation?",
      content: `
       This is just a dummy text that has been inserted as a
                          placeholder for future content. While it may seem
                          insignificant at first glance, the use of dummy text
                          is a common practice in the design and publishing
                          industry, as it allows designers and developers to
                          visualize the layout and overall aesthetic of a
                          project without being distracted by the actual
                          content.
      `,
    },
    {
      title: " Are there any types of furniture you cannot remove?",
      content: `
       This is just a dummy text that has been inserted as a
                          placeholder for future content. While it may seem
                          insignificant at first glance, the use of dummy text
                          is a common practice in the design and publishing
                          industry, as it allows designers and developers to
                          visualize the layout and overall aesthetic of a
                          project without being distracted by the actual
                          content.
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <i class="fa-solid fa-chevron-down"></i>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default FAQsPricing;
